<div class="content-page">
  <!-- Headline -->
  <div class="content-headline">
    <div>
      <h3 class="headline-title">Workflows</h3>
    </div>
  </div>

  <!-- Content -->
  <div class="content-body">
    <div class="cards-wrapper">
      <div
        *ngFor="let workflow of workflowsList"
        class="card"
        [ngClass]="{ selected: selectedWorkflowID == workflow.id }">
        <div class="card-header" [ngSwitch]="workflow.id">
          <div *ngSwitchCase="1" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/topview.svg" />
            <img src="/assets/img/sitesbuilder/workflows/seatmap.svg" />
            <img src="/assets/img/sitesbuilder/workflows/view360.svg" />
          </div>
          <div *ngSwitchCase="2" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/area.svg" />
            <img src="/assets/img/sitesbuilder/workflows/topview.svg" />
            <img src="/assets/img/sitesbuilder/workflows/seatmap.svg" />
            <img src="/assets/img/sitesbuilder/workflows/view360.svg" />
          </div>
          <div *ngSwitchCase="3" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/main.svg" />
          </div>
          <div *ngSwitchCase="4" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/main.svg" />
            <img src="/assets/img/sitesbuilder/workflows/view360.svg" />
          </div>
          <div *ngSwitchCase="5" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/topview.svg" />
            <img src="/assets/img/sitesbuilder/workflows/view360.svg" />
          </div>
          <div *ngSwitchCase="6" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/view360.svg" />
          </div>
          <div *ngSwitchCase="7" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/topview.svg" />
            <img src="/assets/img/sitesbuilder/workflows/seatmap.svg" />
          </div>
          <div *ngSwitchCase="8" class="header-imgs">
            <img src="/assets/img/sitesbuilder/workflows/topview.svg" />
          </div>
        </div>
        <div class="card-body">
          <p class="text-end">ID: {{ workflow.id }}</p>
          <p class="mt-2 text-center fw-bold">{{ workflow.name }}</p>
        </div>
        <div class="card-footer">
          <button class="btn-secondary" (click)="goToWorkflow(workflow)">Start</button>
        </div>
      </div>
    </div>
  </div>
</div>
